import { Button, ButtonProps, forwardRef } from '@chakra-ui/react';
import React from 'react';
import { ThemeUtils } from '../../../utils/theme.utils';

type GradientButtonProps = ButtonProps & {};

const GradientButton = forwardRef<GradientButtonProps, 'button'>(({ children, ...props }, ref) => {
    return (
        <Button
            ref={ref}
            color="background"
            variant="solid"
            transition={'0.5s'}
            backgroundImage={ThemeUtils.actionGradient()}
            backgroundSize="200% auto"
            _hover={{ backgroundPosition: 'right bottom' }}
            _active={{ backgroundPosition: 'right bottom' }}
            {...props}
        >
            {children}
        </Button>
    );
});

export default GradientButton;
